import React, { useEffect, useState } from "react";
import {
  Box,
  Select,
  Spinner,
  Text,
} from "@chakra-ui/react";

const PartySelect = ({
  label = "Select Party",
  selectedParty,
  onChange,
  role,
  size = "md",
  height = undefined,
}) => {
  const [parties, setParties] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchParties = async () => {
      setLoading(true);
      try {

        const url = new URL("https://directory.poc.mrc.ai/api/parties");
        if (role) {url.searchParams.set("roleCode", role);}

        const res = await fetch(url.toString());
        const json = await res.json();

        if (Array.isArray(json)) {
          const sorted = [...json].sort((a, b) =>
            (a.name || "").localeCompare(b.name || "")
          );
          setParties(sorted);
        } else {
          setParties([]);
        }
      } catch (err) {
        console.error("Failed to fetch parties:", err);
        setParties([]);
      } finally {
        setLoading(false);
      }
    };

    fetchParties();
  }, [role]);

  return (
    <Box>
      {label && <Text mb={2}>{label}</Text>}
      {loading ? (
        <Spinner size={size} />
      ) : (
        <Select
          placeholder="Select party..."
          value={selectedParty?._id || ""}
          onChange={(e) => {
            const party = parties.find(p => p._id === e.target.value);
            onChange(party || null);
          }}
          size={size}
          height={height}
          isDisabled={false}
        >
          {parties.map((party) => (
            <option key={party._id} value={party._id}>
              {party.name}
            </option>
          ))}
        </Select>
      )}
    </Box>
  );
};

export default PartySelect;
